import React, { useState, useEffect } from "react"
import { navigate, Link } from "gatsby"
import { useStore } from "../teafuljs/store"
import { getTranslation } from "../scripts/getTranslation"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import MobileStepper from "@material-ui/core/MobileStepper"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft"
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight"
import ReadTogetherImage from "../../static/images/SourceViewCarousel.png"
import SphereViewImage from "../../static/images/SphereViewCarousel.png"
import DataChartsImage from "../../static/images/DataChartsCarousel.png"
import GAPImage from "../../static/images/quotationPopup.gif"

const SVBCarouselOptions = [
  {
    label: "home_title1",
    imgPath: ReadTogetherImage,
    url: "/sourceView",
  },
  {
    label: "layers_sphereview",
    imgPath: SphereViewImage,
    url: "/sphereView",
  },
  {
    label: "data_charts",
    imgPath: DataChartsImage,
    url: "/dataCharts",
  },
  // {
  //   label: "leaders_header",
  //   imgPath:
  //     "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80",
  //   url: "/HowLeadersUseTool",
  // },
]

const useStyles = makeStyles(theme => ({
  root: {
    // maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 50,
  },
  imgContainer: {
    textAlign: "center",
  },
  img: {
    height: 255,
    // maxWidth: 400,
    overflow: "hidden",
    display: "block",
    width: "100%",
    objectFit: "contain",
  },
}))

export default function TextMobileStepper() {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const classes = useStyles()
  const theme = useTheme()
  const [
    activeStep,
    setActiveStep,
  ] = useState(0);


  const maxSteps =
    SVBCarouselOptions.length

  const handleNext = () => {
    setActiveStep(
      prevActiveStep => {
        if (prevActiveStep === SVBCarouselOptions.length - 1) {
          return 0
        } else {
          return prevActiveStep + 1
        }
    })
  }

  const handleBack = () => {
    setActiveStep(
      prevActiveStep =>
        prevActiveStep - 1
    )
  }

  // Automatically change the active step every 3 seconds
  useEffect(() => {
    const interval = setInterval(
      () => {
        // Increment the active step
        handleNext()

        // Reset the active step to 0 if it exceeds the maximum step count
        if (
          activeStep >=
          maxSteps - 1
        ) {
          setActiveStep(0)
        }
      },
      3000
    ) // 3000 milliseconds = 3 seconds

    // Clear the interval when the component unmounts
    return () =>
      clearInterval(interval)
  }, [activeStep])

  function navigateToPage(pageUrl) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: null,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    navigate(pageUrl)
  }

  return (
    <div className={classes.root}>
      {/* <Paper square elevation={0} className={classes.header}>
        <Typography>
          {getTranslation(
            translations,
            language,
            "UI",
            SVBCarouselOptions[activeStep].label
          )}
        </Typography>
      </Paper> */}
      <div className={classes.imgContainer}>
        <img
          className={classes.img}
          src={SVBCarouselOptions[activeStep].imgPath}
          alt={SVBCarouselOptions[activeStep].label}
          onClick={() => {
            navigateToPage(SVBCarouselOptions[activeStep].url)
          }}
        />
      </div>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="text"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </Button>
        }
      />
      <div style={{width: "100%", textAlign: "center"}}>
        <Button
          style={{ width: 180 }}
          data-cy="footerRead"
          size="small"
          color="secondary"
          variant="contained"
          onClick={() => navigateToPage(SVBCarouselOptions[activeStep].url)}
        >
          {getTranslation(
            translations,
            language,
            "UI",
            SVBCarouselOptions[activeStep].label
          )}
        </Button>
      </div>
    </div>
  )
}
